import React from "react";
import PropTypes from "prop-types";
import Detail from "../../../components/user/workingPart/workingPartDetail";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const WorkingPartTechnicalDetailPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Detail uuid={uuid} isTechnical />} />;
};

WorkingPartTechnicalDetailPage.propTypes = {};

export default WorkingPartTechnicalDetailPage;
